module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/moreIcon.5c97b901.svg";